import { Field } from 'react-final-form';
import * as React from 'react';

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function FormCondition({ when, is, children }) {
    return (
        <Field name={when} subscription={{ value: true }}>
            {({ input: { value } }) => {
                return (isFunction(is) ? is(value) : value === is) === true ? children : null;
            }}
        </Field>
    );
}
